export default "__VITE_ASSET__DkDhYB5B__"